'use client';

import { SiteLocale } from '@graphql/generated';
import { useAppContext } from '@lib/context/appContext';
import t from '@lib/locales';
import { TabAction } from '@src/types/tabAction';
import { usePathname, useRouter } from 'next/navigation';
import { BackIcon } from '..';
import { Logout } from './Logout';

type Props = {
  locale: SiteLocale;
  titles?: string[];
  activeIndex?: number;
  actions?: TabAction[];
  showBack?: boolean;
  changeTab?: (tabIndex: number) => void;
};

export const TabButtons = ({
  locale,
  titles = [],
  activeIndex = 0,
  actions,
  showBack = true,
  changeTab,
}: Props) => {
  const router = useRouter();
  const { state } = useAppContext();
  const { baseUrl } = state;
  const currentUrl = usePathname();

  const handleBackButtonClick = () => {
    if (currentUrl.includes('/shipping/modify') || currentUrl.includes('/shipping/new')) {
      router.push(`${baseUrl}/${locale}/account/shipping`);
    } else if (currentUrl.includes('/billing/modify') || currentUrl.includes('/billing/new')) {
      router.push(`${baseUrl}/${locale}/account/billing`);
    } else {
      router.push(`${baseUrl}/${locale}/account`);
    }
  };

  return (
    <div className="tab-buttons-main">
      <div className="tab-buttons__left">
        {showBack && (
          <button
            type="button"
            className="tab-buttons__left__back__label button--link"
            onClick={() => {
              handleBackButtonClick();
            }}
          >
            <BackIcon />
            {t(locale, 'section_account_back')}
          </button>
        )}
        {titles.map((title, index) => {
          return (
            <button
              key={index}
              type="button"
              className={`tab-buttons__item ${
                activeIndex === index ? 'tab-buttons__item__active' : ''
              }`}
              disabled={activeIndex < index}
              onClick={() => {
                if (changeTab) {
                  changeTab(index);
                }
              }}
            >
              {title}
            </button>
          );
        })}
      </div>
      {actions && <Logout actions={actions} />}
    </div>
  );
};
